import React from "react";
import BasePage from "../../base/BasePage";
import SignUpPresenter from "./SignUpPresenter";
import { signUpUseCase } from "../../usecases/user";
import { updateObjectUseCase } from "../../usecases/object";
import withRouter from "../../utils/withRouter";
import CreateSignupForm from "./components/CreateSignupForm";
import { getSchemaUseCase } from "../../usecases/schema/usecases";
import { Progress } from "../../nq-component";

class SignUpPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new SignUpPresenter(
      this,
      signUpUseCase(),
      updateObjectUseCase(),
      getSchemaUseCase(),
    );
    this.state = { progress: false, userInfo: {} };
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  getFields() {
    this.getSchema("users");
  }

  formSubmit(e) {
    e.preventDefault();
    const { userInfo } = this.state;

    const requiredFields = [
      "affiliate",
      // "branch",
      "areaHeadManager",
      "areaHeadManagerContact",
      "position",
      "department",
    ];

    const emptyFields = requiredFields.filter(
      (field) => !userInfo[field] || userInfo[field].toString().trim() === "",
    );

    if (emptyFields.length > 0) {
      this.showError(`
         Please fill out all fields
        `);
      return;
    }

    this.presenter.submit(this.state.user);
  }

  cancelRegistration() {
    this.navigateTo("/signin");
  }

  onChange(value, field) {
    this.presenter.onChange(value, field);
  }

  setObject(object) {
    this.setState({ userInfo: object });
  }

  transformFieldsToSections(data) {
    const sections = {};

    for (const [fieldKey, fieldValue] of Object.entries(data.fields)) {
      if (fieldValue.section) {
        const sectionName = fieldValue.section;
        if (!sections[sectionName]) {
          sections[sectionName] = { name: sectionName, fields: {} };
        }
        sections[sectionName].fields[fieldKey] = fieldValue;
      }
    }

    return {
      sections: Object.values(sections),
    };
  }

  render() {
    const { userInfo } = this.state;
    const { fields, sections } = this.getSchema("users") || {};

    if (!fields || !sections) return <Progress />;

    const schema = this.transformFieldsToSections({ fields, sections });

    return (
      <div className="vh-100 bg-white">
        <div className="d-flex h-100">
          <div className="container p-3 p-lg-5">
            <div className="bg-white rounded p-3 p-lg-5">
              <div className="row">
                <div className="col-md-6 border-end border-1">
                  <div className="h-100 d-flex ">
                    <div className="text-center p-3 w-100">
                      <img
                        className="img-fluid login-img mb-3"
                        src="/f2.png"
                        alt="company-logo"
                        style={{ width: "6rem" }}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6 p-3 px-lg-5 py-lg-4">
                  <form onSubmit={this.formSubmit.bind(this)}>
                    <div className="row g-3">
                      <CreateSignupForm
                        showError={this.showError.bind(this)}
                        schema={schema}
                        userInfo={userInfo}
                        onChange={this.onChange.bind(this)}
                        cancelRegistration={this.cancelRegistration.bind(this)}
                        loading={this.state.loading}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SignUpPage);
